import React, { Component, useEffect, useState } from 'react'


import { loadTalentQuestions, deleteQuesion, loadTalent, saveQuestionssSortOrder } from '../utils/Network'
import { getDefaultName } from '../utils';
import TalentQuestionContent from './TalentQuestionContent';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'


export default function TalentQuestionsContent({ talent_id, question_id }) {

    const [loading, setLoading] = useState(0);

    const [talent, setTalent] = useState(null);
    const [talentQuestions, settalentQuestions] = useState(null);

    useEffect(() => {
        loadTalent(talent_id).then(Talent => {
            setTalent(Talent);

        });

        loadTalentQuestions(talent_id).then(talentQuestions => {
            settalentQuestions(talentQuestions);

        });

    }, []);


    const handleDelete = (id, e) => {
        setLoading(id);
        deleteQuesion(id).then(() => {
            loadTalentQuestions(talent_id).then(talentQuestions => {
                settalentQuestions(talentQuestions);
            });;
        })
    }

    const reload = () => {
        loadTalentQuestions(talent_id).then(talentQuestions => {
            settalentQuestions(talentQuestions);
        });;
    }

    const onDragEnd = result => {
        const { destination, source, draggableId } = result;

        if (!destination) return;
        if (
            destination.draggableId === source.draggableId &&
            destination.index === source.index
        )
            return;

        var talent = talentQuestions.find(x => x.id == draggableId)
        var temp = talentQuestions;

        temp.splice(source.index, 1)
        temp.splice(destination.index, 0, talent)

        var ids = [];
        temp.forEach(child => {
            ids.push(child.id)
        })

        saveQuestionssSortOrder(ids).then(data => {
            console.log(data)
        })

        settalentQuestions(temp)
    }

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        {talent && getDefaultName(talent.names)} Questions
                        <small>({talentQuestions && talentQuestions.length}) items</small>
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li ><a href="/cms/talents">Talents</a></li>
                        <li className="active">Talent Documents</li>
                    </ol>
                </section>

                <section className="content">

                    <div className="row" style={{ minHeight: "800px" }}>
                        <div className="col-md-6">
                            <div className="box box-primary">
                                <div className="box-header with-border">
                                    <h3 className="box-title">All Questions</h3>
                                </div>
                                <div className="box-body no-padding">
                                    <DragDropContext
                                        onDragEnd={onDragEnd}
                                    >
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Weight</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <Droppable droppableId={'dopaable'}>
                                                {(drop_provided) => (
                                                    <tbody
                                                        ref={drop_provided.innerRef}
                                                        {...drop_provided.dropableProps}
                                                    >
                                                        {talentQuestions && talentQuestions.map((item,index) => (

                                                            <Draggable
                                                                key={item.id}
                                                                draggableId={`${item.id}`}
                                                                index={index}

                                                            >
                                                                {(provided) => (
                                                                    <tr
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        ref={provided.innerRef}
                                                                        className={loading === item.id ? "loading " : ""}
                                                                    >
                                                                        <td>
                                                                            <p>{getDefaultName(item.names)}</p>

                                                                        </td>
                                                                        <td>
                                                                            {item.weight}
                                                                        </td>
                                                                        <td className="text-right">
                                                                            <div className="btn-group">
                                                                                <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                                                    <i className="fa fa-trash"></i>
                                                                                </button>
                                                                                <a href={`talents/${talent_id}/questions/${item.id}`} className="btn btn-default btn-sm">
                                                                                    <i className="fa fa-edit"></i>
                                                                                </a>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                        {drop_provided.placeholder}
                                                    </tbody>
                                                )
                                                }
                                            </Droppable>
                                            <tfoot>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Weight</th>
                                                    <th></th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </DragDropContext>
                                </div>


                            </div>



                        </div>
                        <div className="col-md-6">
                            <TalentQuestionContent callback={reload} talent_id={talent_id} question_id={question_id} />

                        </div>
                    </div>

                </section>

            </div>
        </>



    )
}
